import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import MeasurementCard from './MeasurementCard';

const useStyles = makeStyles(() => ({
  container: {
    margin: 0,
    maxWidth: '100%',
  },
}));

const MeasurementCardTab: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={2} direction="row" className={classes.container}>
        <Grid item xs={12}>
          <MeasurementCard />
        </Grid>
      </Grid>
    </>
  );
};

export { MeasurementCardTab };
